import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { useCallback, useEffect } from "react";
import { UseFormReturn } from "react-hook-form";
import { EntradaProdutoForm } from "../../../schemas/Entrada_Produtos/entrada_produtos";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";
import { FormDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";
import { FornecedorDropDown } from "../../../../../../common/domain/models/fornecedor_dropdown";
import { ProdutoServicoDropDown } from "../../../../../../common/domain/models/produto_servico_dropdown";

import PrimaryButton from "../../../../../../common/components/primary_button";
import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";

type Props = {
  open: boolean;
  saving: boolean;
  reactHookForm: UseFormReturn<EntradaProdutoForm>;
  produtosServicosDropDown: ProdutoServicoDropDown[],
  centroCustoDropDown: CentroCustoDropDown[],
  fornecedorDropDown: FornecedorDropDown[],
  selectedProdutosServicosQuery: ProdutoServicoDropDown[] | null,
  selectedFornecedorQuery: FornecedorDropDown[] | null,
  selectedCentroCustoQuery: CentroCustoDropDown[] | null,
  handleProdutosServicosQueryChange: (items: ProdutoServicoDropDown[] | null) => void;
  handleFornecedorQueryChange: (items: FornecedorDropDown[] | null) => void;
  handleCentroCustoQueryChange: (items: CentroCustoDropDown[] | null) => void;
  onSubmit: (form: any) => void;
  onClose: () => void;
};

export const ReportModal = ({
  open,
  saving,
  reactHookForm,
  produtosServicosDropDown,
  selectedProdutosServicosQuery,
  centroCustoDropDown,
  selectedCentroCustoQuery,
  selectedFornecedorQuery,
  fornecedorDropDown,
  handleFornecedorQueryChange,
  handleCentroCustoQueryChange,
  handleProdutosServicosQueryChange,
  onSubmit,
  onClose,
}: Props) => {
  const handleFormSubmit = (data: any) => {
    const payload = {
      ...data,
    };
    onSubmit(payload);
  };
  useEffect(() => { reactHookForm.reset() }, [reactHookForm])

  const handleClose = useCallback(() => {
    if (!saving) onClose();
  }, [saving, onClose]);

  return (
    <Dialog
      open={open}
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: reactHookForm.handleSubmit(handleFormSubmit),
        }
      }}
      sx={{ "& .MuiDialog-paper": { maxWidth: "1200px", width: "100%" } }}>
      <DialogTitle>
        Entradas Produtos
      </DialogTitle>

      <DialogContent>
        <FormContainer title={"Informações"} arrangement="fullRow">
          <div className="flex flex-col gap-y-4 w-full pt-2">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <DefaultMultiAutocomplete
                label='Fornecedor'
                options={fornecedorDropDown}
                getOptionKey={x => x.idFornecedor}
                getOptionLabel={x => x.nomeFantasia}
                value={selectedFornecedorQuery}
                onChange={handleFornecedorQueryChange}
              />

              <DefaultMultiAutocomplete
                label='Centro Custo'
                options={centroCustoDropDown}
                getOptionKey={x => x.id}
                getOptionLabel={x => x.title}
                value={selectedCentroCustoQuery}
                onChange={handleCentroCustoQueryChange}
              />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <DefaultMultiAutocomplete
                label='Produto'
                options={produtosServicosDropDown}
                getOptionKey={x => x.idProdutoServico}
                getOptionLabel={x => x.descricao}
                value={selectedProdutosServicosQuery}
                onChange={handleProdutosServicosQueryChange}
              />
              <DefaultFormInput
                name="NrNotaFiscal"
                label="N° Nota Fiscal"
                reactHookForm={reactHookForm}
              />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <FormDatePickerInput
                name='Data'
                label='Data Entrada'
                reactHookForm={reactHookForm} />
              <FormDatePickerInput
                name='DataSaida'
                label='Data Saida'
                reactHookForm={reactHookForm} />
            </div>
          </div>
        </FormContainer>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-end flex p-4 gap-4">
          <div className="flex flex-row gap-2">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1
                className="text-sm text-black dark:text-white"
                onClick={handleClose}>
                Cancelar
              </h1>
            </div>

            <div className="w-[120px]">
              {saving ? (
                <PrimaryButton buttonColor="primary-green">
                  Gerando...
                </PrimaryButton>
              ) : (
                <PrimaryButton type="submit" buttonColor="primary-green">
                  Gerar
                </PrimaryButton>
              )
              }
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}